import { useTranslation } from 'react-i18next';
import React, { memo, useMemo, useCallback } from 'react';
import cx from 'clsx';
import { isEmpty } from 'lodash';

import { IconRcFeedMore } from '@/assets/stream';
import { Dropdown } from '@/components';
import { useCurrentAddressInfo } from '@/hooks';

import { FeedArticle, FeedComment } from '../../types';
import { useHideComment, usePinCommentOperate } from './hooks';
import styles from './index.module.scss';

export const CommentMoreAction = memo(
  ({
    comment,
    articleId,
    className,
    article,
    isLowQuality,
  }: {
    comment?: FeedComment;
    articleId: number;
    className?: string;
    article?: FeedArticle;
    isLowQuality: boolean;
  }) => {
    const { t } = useTranslation();

    const { address: currentId, isVerified } = useCurrentAddressInfo();
    const { mutate: pinOperate } = usePinCommentOperate({
      action: comment?.is_pin ? 'unpin' : 'pin',
      commentId: comment?.id!,
    });
    const { mutate: hideComment } = useHideComment({
      articleId,
      commentId: comment?.id!,
      isLowQuality,
    });

    const articleCreatorId = useMemo(() => article?.creator_id, [article?.creator_id]);

    const menu = useMemo(
      () =>
        [
          articleCreatorId === currentId
            ? {
                label: t('CommentMoreAction.pinComment', {
                  context: comment?.is_pin ? 'unpin' : 'pin',
                }),
                onClick: () => pinOperate(),
              }
            : undefined,
          currentId === comment?.creator_id
            ? {
                label: t('CommentMoreAction.1c7du'),
                onClick: () => hideComment(),
              }
            : undefined,
        ].filter(i => !!i) as {
          label: string;
          onClick: () => void;
        }[],
      [
        articleCreatorId,
        comment?.creator_id,
        comment?.is_pin,
        currentId,
        hideComment,
        pinOperate,
        t,
      ],
    );

    const handleMoreClick = useCallback((e: React.MouseEvent<HTMLDivElement>) => {
      e.stopPropagation();
    }, []);

    return !isEmpty(menu) && isVerified ? (
      <>
        <Dropdown overlayClassName={styles.menuDropdown} data={menu} placement="bottomRight">
          <div onClick={handleMoreClick} className={cx(styles.commentMoreOp, className)}>
            <IconRcFeedMore />
          </div>
        </Dropdown>
      </>
    ) : null;
  },
);
